import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Mail, X, MessageSquare } from "lucide-react";
import { CONTACT } from "../../data";
import { useLang } from "../../i18n";

export const StickyContact = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3"
          data-testid="sticky-contact"
        >
          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                className="flex flex-col gap-2"
              >
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  data-testid="sticky-call"
                  className="flex items-center gap-3 bg-[#0f1c40] border border-white/10 rounded-full pl-4 pr-5 py-3 text-white text-sm font-medium shadow-xl hover:border-amber-400/50 transition-colors"
                >
                  <Phone size={16} className="text-amber-400" />
                  {CONTACT.phone}
                </a>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="sticky-email"
                  className="flex items-center gap-3 bg-[#0f1c40] border border-white/10 rounded-full pl-4 pr-5 py-3 text-white text-sm font-medium shadow-xl hover:border-amber-400/50 transition-colors"
                >
                  <Mail size={16} className="text-amber-400" />
                  {t.sticky.email}
                </a>
              </motion.div>
            )}
          </AnimatePresence>
          <button
            onClick={() => setOpen(!open)}
            data-testid="sticky-toggle"
            className="h-14 w-14 rounded-full bg-amber-400 hover:bg-amber-300 text-[#060c1f] flex items-center justify-center shadow-2xl glow-gold transition-colors"
            aria-label="Contact options"
          >
            {open ? <X size={22} /> : <MessageSquare size={22} />}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
